export default "__VITE_ASSET__abbcf035__"